import styled from 'styled-components';

export const MenuItemContainer = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  box-shadow: ${({ theme }) => theme.shadows[2]};
  border-radius: 8px;
  overflow: hidden;
`;
